import { useEffect, useState } from 'react';

/**
 * useOnlineStatus
 *
 * React hook that returns the user's online status.
 * Returns true if the browser is online, false if offline.
 * Listens to the browser's 'online' and 'offline' events and updates accordingly.
 *
 * Example usage:
 *   const isOnline = useOnlineStatus();
 */
export function useOnlineStatus() {
    const [online, setOnline] = useState(navigator.onLine);

    useEffect(() => {
        const goOnline = () => setOnline(true);
        const goOffline = () => setOnline(false);
        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);
        return () => {
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, []);

    return online;
}
